import React from 'react';

import { ChevronRight } from '@mui/icons-material';
import { Card, CardActionArea, CardContent, Collapse, Stack, Typography } from '@mui/material';
import PermissionPanel from './permission_panel';

type Restaurant = {
  id: string;
  name?: string | null;
  branchName?: string | null;
  permissions?: { id: string; name?: string | null }[] | null;
};

export type RestaurantCardProps = {
  userId?: string | null;
  restaurant: Restaurant;
  disabled?: boolean;
  editable?: boolean;
};

const RestaurantPermissionCard = ({ userId, restaurant, disabled, editable = true }: RestaurantCardProps) => {
  const [showPermissionPanel, setShowPermissionPanel] = React.useState(false);
  const togglePermissionPanel = React.useCallback(() => {
    setShowPermissionPanel((prev) => !prev);
  }, []);

  return (
    <Card key={restaurant.id} variant="outlined">
      <CardActionArea onClick={togglePermissionPanel}>
        <CardContent component={Stack} flexDirection="row" alignItems="center" gap={0.5}>
          <Typography variant="body1" sx={{ flex: 1 }}>
            {restaurant.name} {restaurant.branchName}
          </Typography>
          <ChevronRight
            sx={{ transform: showPermissionPanel ? 'rotate(90deg)' : 'rotate(0deg)', transition: 'transform 0.3s' }}
          />
        </CardContent>
      </CardActionArea>

      <Collapse in={showPermissionPanel} unmountOnExit>
        <CardContent>
          <PermissionPanel
            hideRestaurantSelector
            userId={userId}
            restaurant={restaurant}
            permissions={restaurant.permissions}
            disabled={disabled}
            editable={editable}
          />
        </CardContent>
      </Collapse>
    </Card>
  );
};

export default RestaurantPermissionCard;
